import { makeStyles } from "@mui/styles";

const useCreateStyles = makeStyles((theme) => ({
    innerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "0.5px solid",
        borderColor: theme.palette.grey.main,
        width: "50%",
        marginBottom: "3rem",
        paddingBottom: "1rem"
    },
    outerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
}));

export default useCreateStyles;
